/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchBookingRulesRequestAction } from 'src/effects/Availability/actions'
import { getIsBookingRulesLoading } from 'src/effects/Availability/selectors'
import { useSession } from 'src/hooks/useSession'

import OfferPrice from '../OfferPrice'

import { mapBoardToPriceData } from 'client/components/PriceDetails/mappers'

import styles from './styles.module.css'
import type { PriceDataType } from 'client/components/PriceDetailsFactory'
import { DiscountBadge } from 'src/comps/Atom/Badges/Discount'
import BookingButton from 'src/comps/Atom/Buttons/BookingButton'

interface OfferResponsivePriceAndButtonsProps {
  board: any
  isLoading?: boolean
  isMultiRoom: boolean
  isSelected: boolean
  nights: number
  onClick: (arg: any) => void
  prime?: boolean
  showMore?: JSX.Element
}

const OfferResponsivePriceAndButtons = ({
  board,
  isLoading = false,
  isMultiRoom,
  isSelected,
  nights,
  onClick,
  prime = false,
  showMore,
}: OfferResponsivePriceAndButtonsProps) => {
  const dispatch = useDispatch()
  const { id: sessionId } = useSession()
  const isBookingRulesLoading = useSelector(getIsBookingRulesLoading)

  useEffect(() => {
    if (board.isRecheck) {
      dispatch(fetchBookingRulesRequestAction({ availabilityId: board.availabilityId, sessionId }))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const priceData: PriceDataType = useMemo(
    () => mapBoardToPriceData({ ...board, nights }),
    [board, nights]
  )

  const isPriceLoading = () => {
    return isBookingRulesLoading[board.availabilityId]
  }

  return (
    <div className={styles.priceAndButtonBookingContainer}>
      <div
        className={styles.priceBookingContainer}
        data-testid="room-prices"
        data-availability-id={board.availabilityId}
        data-payment-policy={board.paymentPolicy}
        data-provider={board.provider}
        data-credential-source={board.credentialSource}
        data-catalogue={board.catalogue}
        data-currency={board.currency}
        data-total-price={board.total}
      >
        {board.discount && <DiscountBadge discount={board.discount} isPrime={prime} />}
        <OfferPrice
          board={board}
          priceData={priceData}
          nights={nights}
          prime={prime}
          loading={isPriceLoading()}
          showDiscountBadge={false}
        />
      </div>
      <div className={styles.bookingButtonContainer}>
        <BookingButton
          data-testid="button-book-room"
          isLoading={isLoading}
          disabled={isLoading && !isSelected}
          isMultiRoom={isMultiRoom}
          onClick={onClick}
          size="m"
          type="button"
        />
      </div>
      {showMore && <div className={styles.showMoreContainer}>{showMore}</div>}
    </div>
  )
}

export default OfferResponsivePriceAndButtons
